export default {"src":"/_next/static/media/boomerang.a6682322.svg","height":12,"width":8,"blurWidth":0,"blurHeight":0};